

import addressData from '@/assets/js/addressTree';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


const defaultLabel = { label: '请选择', id:0, }
export default {
directives: {
TransferDom
},
props:{
show: false,
},
data(){
return {
selectIndex: 0,
selected: [defaultLabel],
selectTree: [addressData],
}
},
methods:{


changeLevelIndex(item,index){
this.selectIndex = index;
},


toNextLevel(item){
if(item.children.length > 0){
this.selected.splice(this.selectIndex,100,{label:item.label,id:item.id},defaultLabel);
this.selectTree.splice(this.selectIndex+1,100,item.children);
this.selectIndex++;
return;
}

this.selected.splice(this.selectIndex,1,item);
this.$emit('onFinish', this.selected)
},


close(){
this.$emit('onClose', false)
},
},
mounted(){

}
}



// WEBPACK FOOTER //
// ./src/components/ui/addressBox.vue